// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4985":"cde938b0fa1cb44b","5175":"760fdd1a2ea35beb","6435":"b9477882f1bba8b4","7021":"b9477882f1bba8b4"}[chunkId] + ".css";
};